export default __webpack_public_path__ + "static/media/in1.e88ef86c.jpg";